import { lazy } from 'react'

export const EmailVariant5 = lazy(() => import('./EmailVariant5'))
